<div class="flex flex-row space-x-1 self-start">
  <div
    *ngIf="post.wisee?.wellBeing"
    class="w-5 h-5 rounded-full bg-value-wellbeing flex justify-center items-center ring-2 ring-white"
  >
    <ark-icon icon="value-category-wellbeing-icon" color="light" size="small">
    </ark-icon>
  </div>

  <div
    *ngIf="post.wisee?.integrity"
    class="w-5 h-5 rounded-full bg-value-integrity flex justify-center items-center ring-2 ring-white"
  >
    <ark-icon icon="value-category-integrity-icon" color="light" size="small">
    </ark-icon>
  </div>

  <div
    *ngIf="post.wisee?.social"
    class="w-5 h-5 rounded-full bg-value-social flex justify-center items-center ring-2 ring-white"
  >
    <ark-icon icon="value-category-social-icon" color="light" size="small">
    </ark-icon>
  </div>

  <div
    *ngIf="post.wisee?.economy"
    class="w-5 h-5 rounded-full bg-value-economic flex justify-center items-center ring-2 ring-white"
  >
    <ark-icon icon="value-category-economic-icon" color="light" size="small">
    </ark-icon>
  </div>

  <div
    *ngIf="post.wisee?.environment"
    class="w-5 h-5 rounded-full bg-value-environmental flex justify-center items-center ring-2 ring-white"
  >
    <ark-icon
      icon="value-category-environmental-icon"
      color="light"
      size="small"
    >
    </ark-icon>
  </div>
</div>
